import { StatesToDisplayItem, DisplayProcessingLogics, PoolDeviceCriticalDesiredActual } from "../Types";
import { IOnoffable, PoolDeviceInterface } from "../Interfaces";
import Locale from "../../utils/Locale";
import { DeviceTypes } from "../../config/documents/HardwareConfig";
import PoolDeviceOnOffable from "./base-onoffable";


export enum criticalFieldIdentifiers {
    OnOff = "OnOff"
}

export default class PoolDevicePressureSensor extends PoolDeviceOnOffable implements PoolDeviceInterface, IOnoffable {
    static CanBeAddedToflow = true;
    static DeviceType = DeviceTypes.PRESSURESENSOR;
    static Icon = "gauge";
    OnOffIdentifier = criticalFieldIdentifiers.OnOff;
    static PickerTitle = Locale.gettext("Pressure Sensor");

    
    getDisplayNameTranslated(displayName:string) {
        switch (displayName) {
        case "Battery Level": return Locale.gettext("Battery Level");
        case "Batt": return Locale.gettext("Batt");
        case "Error": return Locale.gettext("Error");
        case "Pressure": return Locale.gettext("Pressure");
        default: return super.getDisplayNameTranslated(displayName);
        }
    }

    getCriticalFields(): PoolDeviceCriticalDesiredActual[] {
        let order = 0;
        const fields = [];
    
        {
            const DisplayName = Locale.gettext("Power");
            const common = {
                DisplayName, DisplayNameShort: DisplayName,
                DisplayOrder: ++order,
                DisplayProcessingLogic: DisplayProcessingLogics.ONOFF,
                DisplayProcessingLogicUnitAsDisplayName: false,
            };
            fields.push({
                Identifier: criticalFieldIdentifiers.OnOff,
                ActualProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.ActualPowerState }, common),
                DesiredProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.PowerState }, common)
            });
        }
    
        return fields;
    }
    
    getInformationFields(): StatesToDisplayItem[] {
        let order = 0;
        const fields = [];
    
        fields.push({
            Name: PoolsideDaemonDeviceStateNames.PressurePsi,
            DisplayName: "Pressure",
            DisplayNameShort: "Pressure",
            DisplayOrder: ++order,
            DisplayProcessingLogic: DisplayProcessingLogics.PSI,
            DisplayProcessingLogicUnitAsDisplayName: true,
        });
        fields.push({
            Name: PoolsideDaemonDeviceStateNames.BatteryLevel,
            DisplayName: "Battery Level",
            DisplayNameShort: "Batt",
            DisplayOrder: ++order,
            DisplayProcessingLogic: DisplayProcessingLogics.PERCENT,
            DisplayProcessingLogicUnitAsDisplayName: false,
        });
        /*
        fields.push({
            Name: PoolsideDaemonDeviceStateNames.Error,
            DisplayName: "Error",
            DisplayNameShort: "Error",
            DisplayOrder: ++order,
            DisplayProcessingLogic: DisplayProcessingLogics.STRING,
            DisplayProcessingLogicUnitAsDisplayName: false,
        });
        */
        return fields;
    }    
}

export enum PoolsideDaemonDeviceStateNames {
    ActualPowerState = "ActualPowerState",
    BatteryLevel = "BatteryLevel",
    Error = "Error",
    PowerState = "PowerState",
    PressurePsi = "PressurePsi",
}
